import { computed, inject, onMounted, ref, type ComputedRef } from 'vue';

import { cloneDeep } from 'lodash';

import { useUserStore } from '@/stores/user';
import { ij_settingsCached } from '@/utils/injectionKeys.js';

export const useGauge = (userPreference: string, isGlobal: boolean) => {
  const userStore = useUserStore();

  const cachedSettings = inject<ComputedRef>(ij_settingsCached);

  const valueLocal = ref(cloneDeep(userStore.userPreferences[userPreference]));

  const valueDisplayed = computed(() => (isGlobal ? userStore.userPreferences[userPreference] : valueLocal.value));

  const setDefaultFromCache = () => {
    const cached = cachedSettings?.value;
    if (!cached) return;
    if (cached[userPreference] === undefined) return;
    valueLocal.value = cached[userPreference];
  };

  onMounted(setDefaultFromCache);

  return {
    valueLocal,
    valueDisplayed,
    cachedSettings,
    setDefaultFromCache,
  };
};
